/**
 * Steuernummer: akzeptiert die deutsche LOKALE Form (10–11 Ziffern, ggf. mit
 * "/" oder Leerzeichen gruppiert) ODER die 13-stellige bundeseinheitliche
 * (ELSTER-)Nummer. Bei 13 Stellen sind die ersten 4 Ziffern die BUFA
 * (Bundesfinanzamtsnummer) → fürs Finanzamt-Lookup. Keine Bundesland-spezifische
 * Umrechnung. Speicherung erfolgt as-typed (nur getrimmt).
 */

export type SteuernummerKind = "elster13" | "local" | "unknown";

export interface SteuernummerParse {
  valid: boolean;
  kind: SteuernummerKind;
  /** 4-stellige BUFA, nur bei kind === "elster13". */
  bufa?: string;
  /** Nur-Ziffern-Form. */
  digits: string;
  error?: string;
}

export function parseSteuernummer(input: string): SteuernummerParse {
  const raw = String(input ?? "").trim();
  const digits = raw.replace(/\D/g, "");
  if (!raw) return { valid: true, kind: "unknown", digits: "" };
  if (digits.length === 13) {
    return { valid: true, kind: "elster13", bufa: digits.slice(0, 4), digits };
  }
  if (digits.length >= 10 && digits.length <= 11) {
    return { valid: true, kind: "local", digits };
  }
  return {
    valid: false,
    kind: "unknown",
    digits,
    error: "Format prüfen: lokale Steuernr. (10–11 Ziffern) oder 13-stellig",
  };
}

export function validateSteuernummer(input: string): { valid: boolean; error?: string } {
  const p = parseSteuernummer(input);
  return p.valid ? { valid: true } : { valid: false, error: p.error };
}
